$.fn.myScroller = function(options) {
	var isScrolling = false;
	var isMouseDown = false;
    var resizeTO;
	 var defaults = {
		scrollupClass: ".myscroller_up",
		scrolldownClass: ".myscroller_down",
		listContainer: "#mylist",
		topOffset: 0,
		scrollSpeedPx: 100,
		defaultOpacity: 0.4,
		animationSpeed: 'slow'
	};
  	var o = $.extend(defaults, options);
  	
	return this.each(function() {
		var me = $(this);
		var scrollUp = me.find(o.scrollupClass);
		var scrollDown = me.find(o.scrolldownClass);
		
		me.addClass("myscroller_container");
		$(o.listContainer).addClass("myscroller_list");
		
		toggleScrollers();
		
		scrollUp.bind("click", function() {
			scrollListDown();
		});
		
		scrollDown.bind("click", function() {
				
          	scrollListUp();
		});
        
        $(scrollDown,scrollUp).bind("mouseover", function() {
           $(this).addClass("hover"); 
        });
        
        $(scrollDown,scrollUp).bind("mouseout", function() {
           $(this).removeClass("hover"); 
        });
		
		scrollDown.bind("mousedown", function() {
			isMouseDown = true;
			scrollListDown();
			return false;
		});
		
		scrollUp.bind("mousedown", function() {
			isMouseDown = true;
			scrollListUp();
			return false;
		});
        
        me.bind("mousewheel",function(e, delta) {
          if ( $(window).width() < 480 ) return;
          
           if(delta < 0) {
               if(isDisplayed(scrollDown)) scrollListDown();
           }
           else {
                if(isDisplayed(scrollUp))scrollListUp();
           }
           return false;
        });
		
		$(document).mouseup( function() { 
			isMouseDown = false;
		});
        
        $(window).resize(function() {
            if(resizeTO) clearTimeout(resizeTO);
            resizeTO = setTimeout(function() {
                $(this).trigger('resizeEnd');
            }, 500);
        });
		
        $(window).bind('resizeEnd', function() {
            toggleScrollers();
        });
        
        me.bind("toggleScroller", function() {
            toggleScrollers();
        });
	
		function scrollListUp() {
			var listTop = $(o.listContainer).position().top;
			if(!isScrolling) {
				isScrolling = true;
				$(o.listContainer).animate({top: Math.min( (listTop + o.scrollSpeedPx),0)}, o.animationSpeed, function() {
					isScrolling = false;
					toggleScrollers();
					if(isMouseDown) scrollListUp();
				});
			}
			
		}
		
		function scrollListDown() {
			var listTop = $(o.listContainer).position().top;
			var endList = (-1) * ( $(o.listContainer).outerHeight() - me.outerHeight() );
			if(!isScrolling) {
				isScrolling = true;
				$(o.listContainer).animate({top: Math.max(listTop - o.scrollSpeedPx, endList)}, o.animationSpeed, function() {
					isScrolling = false;
					toggleScrollers();
					if(isMouseDown) scrollListDown();
				});
			}
			
		}
		
		function toggleScrollers() {
			var listTop = $(o.listContainer).position().top;
			var listHt = $(o.listContainer).outerHeight();
			var ctrHeight = me.outerHeight();
			if(ctrHeight >= listHt) {
				if(isDisplayed(scrollUp)) scrollUp.fadeTo(o.animationSpeed, 0);
				if(isDisplayed(scrollDown)) {scrollDown.fadeTo(o.animationSpeed, 0); }
              	me.removeClass('hasScrollUp hasScrollDown');
              $(o.listContainer).animate({top : o.topOffset});
			}
            else {
    			if(listTop - o.topOffset == 0) { // list shows first item 
    				if(isDisplayed(scrollUp)) scrollUp.fadeTo(o.animationSpeed, 0);
                  	me.removeClass('hasScrollUp');
    			}
    			else {
    				if(scrollUp.is(":hidden")) scrollUp.show(); 
    				else if(!isDisplayed(scrollUp)) scrollUp.fadeTo(o.animationSpeed, o.defaultOpacity);
                    me.addClass('hasScrollUp');
    			}
    			if(listTop == -1 * (listHt - ctrHeight)) { //list shows last item
    				if(isDisplayed(scrollDown))
    					scrollDown.fadeTo(o.animationSpeed, 0);
                 	me.removeClass('hasScrollDown');
    			}
    			else {
    				if(scrollDown.is(":hidden"))  scrollDown.show();
    				else if(!isDisplayed(scrollDown)) scrollDown.fadeTo(o.animationSpeed, o.defaultOpacity);
                    me.addClass('hasScrollDown');
    			}
            }
		}
		
		function isDisplayed(element) {
			if(element.is(":visible") && element.css("opacity") >0) return true;
			return false;
		}
	
	});

};